export const MARKET_MONITOR_TOOLTIP_PROPS = {
  // Prefer right-of-cursor tooltip, but auto-flip left when near right edge.
  offset: 24,
  reverseDirection: { x: true, y: false } as const,
  allowEscapeViewBox: { x: false, y: false } as const,
  wrapperStyle: { pointerEvents: "none" as const },
  contentStyle: {
    backgroundColor: "rgba(248, 250, 252, 0.88)",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.12)",
    padding: "8px 10px",
  },
  labelStyle: {
    color: "#111827",
    fontSize: "12px",
    fontWeight: 700,
    marginBottom: 2,
  },
  itemStyle: {
    color: "#111827",
    fontSize: "12px",
    fontWeight: 600,
    padding: 0,
  },
};